/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Dl_Macos_ReqInputs */

const en_fc_dl_macos_req = /** @type {(inputs: Fc_Dl_Macos_ReqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`macOS · Universal build for Apple silicon and Intel Macs`)
};

/**
* | output |
* | --- |
* | "macOS · Universal build for Apple silicon and Intel Macs" |
*
* @param {Fc_Dl_Macos_ReqInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_dl_macos_req = /** @type {((inputs?: Fc_Dl_Macos_ReqInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Dl_Macos_ReqInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_dl_macos_req(inputs)
});
export { fc_dl_macos_req as "fc.dl.macos.req" }